import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Util } from '../../util';
import { BookClubHistory } from '../../models/bookclub-history';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookclubHistoryApiService {
  API_URL: string;

  constructor(private http: HttpClient) {
    const url = new URL(Util.getOrigin());
    this.API_URL = `${url.origin}/opac/api/v2/records/bookClubHistory`;
  }

  public getBookClubHistoryByUserIdAndResourceId(userId: string, recordId: string): Observable<BookClubHistory[]> {
    const queryParams = {
      userId: userId,
      recordId: recordId,
    };
    return this.http.get<BookClubHistory[]>(`${this.API_URL}`, {
      params: queryParams,
    });
  }

  public saveBookClubHistory(userId: string, recordId: string, learningExperienceId: string, dontShow: boolean) {
    const queryParams = {
      userId: userId,
      recordId: recordId,
      learningExperienceId: learningExperienceId === '' ? 'plain' : learningExperienceId,
      dontShow: String(dontShow),
    };
    return this.http.put<void>(`${this.API_URL}`, {}, { params: queryParams });
  }
}
